module.exports = __webpack_public_path__ + "static/img/2.65d28ca.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/4/eng/2.png
// module id = 6ImJ
// module chunks = 0